(function () {
    'use strict';
    angular.module('aprima-core-ui').config(['$provide', function ($provide) {
        $provide.decorator('ngClickDirective', [
            '$delegate',
            'ClickListenerService',
            ngClickDecorator
        ]);

        function ngClickDecorator(
            $delegate,
            ClickListenerService
        ) {
            // Completely replace all implementations of the ngClick directive.
            // We need to make sure ngClick hasn't changed when upgrading angular.
            $delegate.forEach(updateDirective);
            return $delegate;

            function updateDirective(directive) {
                // angular somehow knows that ngClick has a compile function and not a link function,
                // so we have to override compile instead of deleting it and using link directly.
                directive.compile = compile;
            }

            function compile() {
                return link;
            }

            function link(scope, element, attrs) {
                ClickListenerService.registerFromDirective(scope, element, attrs, 'ngClick');
            }
        }
    }]);
})();